import $ from 'jquery';

$(document).ready(function () {
  meetingScheduleBlock();
});
function meetingScheduleBlock() {
  $('.js-acf-meeting-schedule-block').each(function () {});
}
